var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Typography } from "@mui/material";
import { t } from "i18next";
import { useDispatch } from "react-redux";
import { BatteryEmptyIndicatorIcon, BatteryFullIndicatorIcon } from "../../../assets/images";
import { fuelIndicatorMarkList_EV, markList } from "../../../constants";
import { setIsFuelIndicatorSliderChanged } from "../../../redux/commonSlice";
import { MuiSlider } from "../../atoms/sliderComponent";
import { MuiStack } from "../../atoms/stackComponent";
import { systemColor } from "../../../theme/systemColor";
var CustomFormFuelIndicator = function (props) {
    var data = props.data, onChangeList = props.onChangeList, isDisabled = props.isDisabled;
    // const [data, setList] = useState<any>(data)
    var dispatch = useDispatch();
    // useEffect(() => {
    //     setList(data)
    // }, [data])
    var handleChangeSlider = function (newValue, QuestionGroupItemIndex, QuestionItemIndex) {
        var updatedQueGroupsList = __spreadArray([], data, true);
        var updatedQuestionGrp = _objectSpread({}, updatedQueGroupsList[QuestionGroupItemIndex]);
        var updatedQuestionItem = _objectSpread({}, updatedQuestionGrp.Questions[QuestionItemIndex]);
        updatedQuestionItem.ResponseValue = newValue;
        updatedQuestionGrp.Questions[QuestionItemIndex] = updatedQuestionItem;
        updatedQueGroupsList[QuestionGroupItemIndex] = updatedQuestionGrp;
        onChangeList(updatedQueGroupsList);
        dispatch(setIsFuelIndicatorSliderChanged(true));
    };
    var RenderQuestionByType = function (QuestionItem, QuestionGroupItemIndex, QuestionItemIndex) {
        switch (QuestionItem.ToolTip) {
            case "ELECTRIC_BOV":
                return /*#__PURE__*/ React.createElement(MuiStack, {
                    direction: "column",
                    spacing: 4
                }, QuestionItem.IsDisplay && /*#__PURE__*/ React.createElement(Typography, {
                    id: QuestionItem.Title,
                    variant: "h3",
                    sx: {
                        textTransform: 'capitalize'
                    }
                }, QuestionItem.Title), /*#__PURE__*/ React.createElement(MuiStack, {
                    paddingX: 2,
                    py: 1,
                    direction: 'column'
                }, /*#__PURE__*/ React.createElement(MuiSlider, {
                    id: "fuel-slider",
                    marks: fuelIndicatorMarkList_EV,
                    step: 1,
                    onChange: function (event, newValue) { return handleChangeSlider(newValue, QuestionGroupItemIndex, QuestionItemIndex); },
                    value: Number(QuestionItem.ResponseValue),
                    disabled: isDisabled,
                    sx: {
                        marginTop: "10px",
                        '& .MuiSlider-rail': {
                            height: 8,
                            borderRadius: 4
                        },
                        '& .MuiSlider-thumb': {
                            height: 24,
                            width: 24,
                            backgroundColor: '#fff',
                            border: '2px solid currentColor',
                            '&:hover': {
                                boxShadow: '0 0 0 8px rgba(25, 118, 210, 0.16)'
                            }
                        },
                        '& .MuiSlider-track': {
                            height: 8,
                            borderRadius: 4
                        },
                        color: systemColor.primary,
                        '& .MuiSlider-valueLabel ': {
                            bgcolor: systemColor.primary,
                            opacity: isDisabled ? 0.7 : 1
                        }
                    }
                }), /*#__PURE__*/ React.createElement(MuiStack, {
                    justifyContent: 'space-between',
                    paddingX: -1
                }, /*#__PURE__*/ React.createElement("img", {
                    height: 20,
                    width: 20,
                    src: BatteryEmptyIndicatorIcon
                }), /*#__PURE__*/ React.createElement("img", {
                    height: 20,
                    width: 20,
                    src: BatteryFullIndicatorIcon
                }))));
            case "CNG":
            case "LPG":
                return /*#__PURE__*/ React.createElement(MuiStack, {
                    direction: "column",
                    spacing: 4
                }, QuestionItem.IsDisplay && /*#__PURE__*/ React.createElement(Typography, {
                    variant: "h3",
                    sx: {
                        textTransform: 'capitalize'
                    }
                }, QuestionItem.Title), /*#__PURE__*/ React.createElement(MuiStack, {
                    sx: {
                        marginTop: "35px",
                        px: 2,
                        py: 1
                    }
                }, /*#__PURE__*/ React.createElement(MuiSlider, {
                    id: "fuel-slider",
                    marks: markList,
                    step: 1,
                    onChange: function (event, newValue) { return handleChangeSlider(newValue, QuestionGroupItemIndex, QuestionItemIndex); },
                    value: Number(QuestionItem.ResponseValue),
                    disabled: isDisabled,
                    sx: {
                        marginTop: "5px",
                        '& .MuiSlider-rail': {
                            height: 8,
                            borderRadius: 4
                        },
                        '& .MuiSlider-thumb': {
                            height: 24,
                            width: 24,
                            backgroundColor: '#fff',
                            border: '2px solid currentColor',
                            '&:hover': {
                                boxShadow: '0 0 0 8px rgba(25, 118, 210, 0.16)'
                            }
                        },
                        '& .MuiSlider-track': {
                            height: 8,
                            borderRadius: 4
                        },
                        color: systemColor.primary,
                        '& .MuiSlider-valueLabel ': {
                            bgcolor: systemColor.primary,
                            opacity: isDisabled ? 0.7 : 1
                        }
                    }
                })));
            default:
                return /*#__PURE__*/ React.createElement(MuiStack, {
                    direction: "column",
                    spacing: 4
                }, QuestionItem.IsDisplay && /*#__PURE__*/ React.createElement(MuiStack, {
                    paddingBottom: 1
                }, /*#__PURE__*/ React.createElement(Typography, {
                    variant: "h3",
                    sx: {
                        textTransform: 'capitalize'
                    }
                }, QuestionItem.Title)), /*#__PURE__*/ React.createElement(MuiStack, {
                    sx: {
                        marginTop: "35px",
                        px: 2,
                        py: 1
                    }
                }, /*#__PURE__*/ React.createElement(MuiSlider, {
                    id: "fuel-slider",
                    marks: markList,
                    step: 1,
                    onChange: function (event, newValue) { return handleChangeSlider(newValue, QuestionGroupItemIndex, QuestionItemIndex); },
                    value: Number(QuestionItem.ResponseValue),
                    disabled: isDisabled,
                    sx: {
                        marginTop: "5px",
                        '& .MuiSlider-rail': {
                            height: 8,
                            borderRadius: 4
                        },
                        '& .MuiSlider-thumb': {
                            height: 24,
                            width: 24,
                            backgroundColor: '#fff',
                            border: '2px solid currentColor',
                            '&:hover': {
                                boxShadow: '0 0 0 8px rgba(25, 118, 210, 0.16)'
                            }
                        },
                        '& .MuiSlider-track': {
                            height: 8,
                            borderRadius: 4
                        },
                        color: systemColor.primary,
                        '& .MuiSlider-valueLabel ': {
                            bgcolor: systemColor.primary,
                            opacity: isDisabled ? 0.7 : 1
                        }
                    }
                })));
        }
    };
    return /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        width: '100%'
    }, data.map(function (QuestionGroupItem, QuestionGroupItemIndex) {
        return /*#__PURE__*/ React.createElement(MuiStack, {
            direction: 'column',
            key: QuestionGroupItemIndex,
            paddingY: 1,
            gap: 1.5
        }, /*#__PURE__*/ React.createElement(Typography, {
            id: "Fuel/Battery indicator",
            fontSize: 'xl',
            fontWeight: 'medium'
        }, t('Fuel/Battery indicator'), " ", ' ', !isDisabled && /*#__PURE__*/ React.createElement("span", null, "*")), /*#__PURE__*/ React.createElement(MuiStack, {
            className: "abc",
            direction: 'column',
            spacing: 1,
            paddingRight: 3,
            paddingLeft: 1.9
        }, QuestionGroupItem.Questions.map(function (QuestionItem, QuestionItemIndex) {
            return /*#__PURE__*/ React.createElement(MuiStack, {
                key: QuestionItemIndex,
                direction: 'column'
            }, RenderQuestionByType(QuestionItem, QuestionGroupItemIndex, QuestionItemIndex));
        })));
    }));
};
export default CustomFormFuelIndicator;
